export default class StringUtils {
    //to covert into camelcase by using same value from language file.
    public convertToCamelCase = (str: unknown): string => {
        let response = '';
        try {
            if (typeof str !== 'string') {
                console.log('convertToCamelCase: input is not a string', str);
            } else {
                const trimmed = str.trim();
                if (trimmed) {
                    response = trimmed
                        .toLowerCase()
                        .replace(/ (.)/, (_, c) => c.toUpperCase());
                }
            }
        } catch (e) {
            console.error('convertToCamelCase failed:', e);
        }

        return response;
    };
}
